// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.dropzone {
    width: 95%;
    min-width: 300px;
    cursor: pointer;
    height: 250px;
    padding: 1rem;
    text-align: center;
    border-radius: 20px;
    margin: 0 auto;
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 6px 0px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.output-summary-container {
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 6px 0px;
    padding: 1rem;
    border-radius: 20px;
    margin: 0 auto;
    min-width: 750px;
    min-height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 95%;
}

.file-item {
    border-radius: 15px;  
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    background: radial-gradient(circle at -1% 57.5%, rgb(129, 176, 139) 0%, rgb(89, 174, 91) 80%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.name {
    font-size: 15px;
    font-weight: 600;
    color: #353f4a;
    margin: 0;
    justify-self: start;
  }


  
  
.dropzone span {
    color: #77A1D3;
    padding: 0px 4px;
    font-size: 15px;
}

  .dropzone input {
    opacity: 0;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
  }
  
  ul {
    padding: 0px;
    margin: 0px;
  }
  

  
  .dropzone h5 {
    color: #aaabad;
    font-weight: 700;
  }
  
  
  .fileover {
    animation: shake 1s;
    animation-iteration-count:infinite;
  }
  

.copy_button {
    background: white;
    border-radius: 15px;
    color: grey;
    line-height: 30px;
    padding: 0 10px
}

.copy_button:focus {
    background: #54c74a;
    color: white
}

  

  
  .size {
    font-size: 12px;
    font-weight: 500;
    color: #e4e2e2;
    margin: 0;
    margin-bottom: 0.25rem;
  }
  
  .info {
    width: 90%
  }
  
  @keyframes extend {
    0% {width: 75%}
    100% {width: 90%}
  }
  
  @keyframes shake {
    0% {
      transform: translate(1px, 1px) rotate(0deg);
    }
  
    10% {
      transform: translate(-1px, -2px) rotate(-1deg);
    }
  
    20% {
      transform: translate(-3px, 0px) rotate(1deg);
    }
  
    30% {
      transform: translate(3px, 2px) rotate(0deg);
    }
  
    40% {
      transform: translate(1px, -1px) rotate(1deg);
    }
  
    50% {
      transform: translate(-1px, 2px) rotate(-1deg);
    }
  
    60% {
      transform: translate(-3px, 1px) rotate(0deg);
    }
  
    70% {
      transform: translate(3px, 1px) rotate(-1deg);
    }
  
    80% {
      transform: translate(-1px, -1px) rotate(1deg);
    }
  
    90% {
      transform: translate(1px, 2px) rotate(0deg);
    }
  
    100% {
      transform: translate(1px, -2px) rotate(-1deg);
    }
  }
  
  .cursor-point {
    cursor: pointer;
  }
  
  .picker-dialog{
    position: fixed !important;
  }

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 100px
}
.prompt {
  padding:0;
  margin-left:10px;
  margin-right:10px;
  width: 300px;
  margin-top:10px;

}
.editor{
  border-radius:10px;
  width:300px
}
.selectable {
  -webkit-user-select: text;
          user-select: text; /* Allow text selection */
}`, "",{"version":3,"sources":["webpack://./src/app/ai-summary/ai-summary.component.css"],"names":[],"mappings":";;;AAGA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,0FAA0F;IAC1F,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0FAA0F;IAC1F,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,4EAA4E;IAC5E,6FAA6F;IAC7F,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,mBAAmB;EACrB;;;;;AAKF;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;EAEE;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;;;EAIA;IACE,cAAc;IACd,gBAAgB;EAClB;;;EAGA;IACE,mBAAmB;IACnB,kCAAkC;EACpC;;;AAGF;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;;;;EAKE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE;EACF;;EAEA;IACE,IAAI,UAAU;IACd,MAAM,UAAU;EAClB;;EAEA;IACE;MACE,2CAA2C;IAC7C;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,2CAA2C;IAC7C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,6CAA6C;IAC/C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,6CAA6C;IAC/C;;IAEA;MACE,2CAA2C;IAC7C;;IAEA;MACE,6CAA6C;IAC/C;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;AAEF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;;AAEjB;AACA;EACE,kBAAkB;EAClB;AACF;AACA;EACE,yBAAiB;UAAjB,iBAAiB,EAAE,yBAAyB;AAC9C","sourcesContent":["\n\n\n.dropzone {\n    width: 95%;\n    min-width: 300px;\n    cursor: pointer;\n    height: 250px;\n    padding: 1rem;\n    text-align: center;\n    border-radius: 20px;\n    margin: 0 auto;\n    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 6px 0px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.output-summary-container {\n    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 6px 0px;\n    padding: 1rem;\n    border-radius: 20px;\n    margin: 0 auto;\n    min-width: 750px;\n    min-height: 350px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 95%;\n}\n\n.file-item {\n    border-radius: 15px;  \n    padding: 10px;\n    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n    background: radial-gradient(circle at -1% 57.5%, rgb(129, 176, 139) 0%, rgb(89, 174, 91) 80%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #353f4a;\n    margin: 0;\n    justify-self: start;\n  }\n\n\n  \n  \n.dropzone span {\n    color: #77A1D3;\n    padding: 0px 4px;\n    font-size: 15px;\n}\n\n  .dropzone input {\n    opacity: 0;\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n  }\n  \n  ul {\n    padding: 0px;\n    margin: 0px;\n  }\n  \n\n  \n  .dropzone h5 {\n    color: #aaabad;\n    font-weight: 700;\n  }\n  \n  \n  .fileover {\n    animation: shake 1s;\n    animation-iteration-count:infinite;\n  }\n  \n\n.copy_button {\n    background: white;\n    border-radius: 15px;\n    color: grey;\n    line-height: 30px;\n    padding: 0 10px\n}\n\n.copy_button:focus {\n    background: #54c74a;\n    color: white\n}\n\n  \n\n  \n  .size {\n    font-size: 12px;\n    font-weight: 500;\n    color: #e4e2e2;\n    margin: 0;\n    margin-bottom: 0.25rem;\n  }\n  \n  .info {\n    width: 90%\n  }\n  \n  @keyframes extend {\n    0% {width: 75%}\n    100% {width: 90%}\n  }\n  \n  @keyframes shake {\n    0% {\n      transform: translate(1px, 1px) rotate(0deg);\n    }\n  \n    10% {\n      transform: translate(-1px, -2px) rotate(-1deg);\n    }\n  \n    20% {\n      transform: translate(-3px, 0px) rotate(1deg);\n    }\n  \n    30% {\n      transform: translate(3px, 2px) rotate(0deg);\n    }\n  \n    40% {\n      transform: translate(1px, -1px) rotate(1deg);\n    }\n  \n    50% {\n      transform: translate(-1px, 2px) rotate(-1deg);\n    }\n  \n    60% {\n      transform: translate(-3px, 1px) rotate(0deg);\n    }\n  \n    70% {\n      transform: translate(3px, 1px) rotate(-1deg);\n    }\n  \n    80% {\n      transform: translate(-1px, -1px) rotate(1deg);\n    }\n  \n    90% {\n      transform: translate(1px, 2px) rotate(0deg);\n    }\n  \n    100% {\n      transform: translate(1px, -2px) rotate(-1deg);\n    }\n  }\n  \n  .cursor-point {\n    cursor: pointer;\n  }\n  \n  .picker-dialog{\n    position: fixed !important;\n  }\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    height: 100px\n}\n.prompt {\n  padding:0;\n  margin-left:10px;\n  margin-right:10px;\n  width: 300px;\n  margin-top:10px;\n\n}\n.editor{\n  border-radius:10px;\n  width:300px\n}\n.selectable {\n  user-select: text; /* Allow text selection */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
